import { styled } from '@styles/stitches';

export const Container = styled('div', {
  position: 'relative',
  backgroundColor: '$secondaryBackground',

  '&:before': {
    content: "''",
    display: 'block',
    width: '1px',
    height: 0,
    paddingBottom: 'calc(100% / (var(--aspect-ratio)))',
  },

  img: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 'auto',
  },

  svg: {
    position: 'absolute',
    bottom: '$4',
    right: '$4',
  },

  variants: {
    detail: {
      true: {
        backgroundColor: '$primaryBackground',

        '&:before': {
          content: 'none',
        },

        img: {
          position: 'unset',
          top: 'unset',
          left: 'unset',
          width: 'auto',
          maxHeight: 'calc(100vh - $space$1 - $space$1)',
        },
      },
    },

    smol: {
      true: {
        img: {
          imageRendering: 'pixelated',
        },
      },
    },
  },
});
